module.exports = __webpack_public_path__ + "img/benefit-curve-mobile.9fdd2c49.svg";